<template>
  <div class="not-found">
    <bg-empty-state
      title="Halaman Tidak Ditemukan"
      description="
        Halaman yang Anda cari tidak tersedia. 
        Mohon periksa kembali alamat yang Anda masukkan.
      "
      illustration-name="error-404"
      illustration-alt="Halaman tidak ditemukan"
      button-text="Kembali ke Beranda"
      @click="goToHomepage"
    />
  </div>
</template>

<script>
import { BgEmptyState } from 'bangul-vue';

export default {
  name: 'NotFound',

  components: {
    BgEmptyState,
  },

  methods: {
    goToHomepage() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped src="./NotFound.scss"></style>
